import { ref, readonly } from 'vue'
import { MensajesApi } from '@/services/MensajeServices'

// Estado global compartido
const unreadCount = ref(0)
const isLoading = ref(false)
let intervalId: number | null = null
let isPollingActive = false

export function useUnreadMessages() {
    const fetchUnreadCount = async () => {
        try {
            isLoading.value = true
            const count = await MensajesApi.getUnreadCount()
            unreadCount.value = count
        } catch (error) {
            console.error('Error fetching unread messages count:', error)
        } finally {
            isLoading.value = false
        }
    }

    const startPolling = (intervalMs = 600000) => { // Default 10 minutos
        if (isPollingActive) {
            return
        }
        
        isPollingActive = true
        fetchUnreadCount() // Fetch inicial
        intervalId = window.setInterval(fetchUnreadCount, intervalMs)
    }

    const stopPolling = () => {
        if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
            isPollingActive = false
        }
    }

    const markAsRead = () => {
        if (unreadCount.value > 0) {
            unreadCount.value--
        }
    }

    const incrementUnread = () => {
        unreadCount.value++
    }

    const resetCount = () => {
        unreadCount.value = 0
    }

    return {
        unreadCount: readonly(unreadCount),
        isLoading: readonly(isLoading),
        fetchUnreadCount,
        startPolling,
        stopPolling,
        markAsRead,
        incrementUnread,
        resetCount
    }
}